(function(){
  setTimeout(() => {
	const double = document.getElementById('swatch-2-double-sided');
  
    if ( double ) {
      const single = document.getElementById('swatch-2-single-sided');
      const variationContainer = document.getElementById('infiniteoptions-container');
      variationContainer.style.display = "none";
      
      setTimeout(() => {
        // Remove name attribute so it doesn't show on Checkout page unnecessarily
        const variationSelect = document.getElementById('Double-Sided Backside Artwork-0-0');
        variationSelect.removeAttribute('name');

        if ( double.checked ) {
          variationContainer.style.display = 'block';
          variationSelect.setAttribute('name', 'properties[Double-Sided Backside Artwork]');
        }

        double.addEventListener('change', function() {
          if ( this.checked ) {
            variationContainer.style.display = 'block';
            variationSelect.setAttribute('name', 'properties[Double-Sided Backside Artwork]');
          } else {
            variationContainer.style.display = 'none';
            variationSelect.removeAttribute('name');
          }
        });

        single.addEventListener('change', function() {
          if ( this.checked ) {
            variationContainer.style.display = 'none';
            variationSelect.removeAttribute('name');
          }
        });
	  }, 3000);
    }
  	
  }, 1000);
})();